import * as Enumerable from 'linq-es2015'


export default {
    props: {
        actionLabel: String,
        index: Number,
        modelId: Object,
        modelObject: Object,
        title: String,
        editMode: Boolean
    },

    data: function () {
        return {
            loading: false,
            model: this.emptyModel(),
            modelErrors: null,
            modelMetadata: {

            },

        }
    },

    computed: {

    },

    methods: {
        fieldHasError: function (field) {
            return this.modelErrors != null && this.modelErrors.hasOwnProperty(field);
        },

        fieldErrorMessage: function (field) {
            if (this.modelErrors == null) {
                return '';
            }

            if (this.modelErrors.hasOwnProperty(field) === false) {
                return '';
            }

            return this.modelErrors[field];
        },

        formFiles: function () {
            let files = [];

            if (this.model.Files != null) {
                files.push(this.model.Files);
            }

            return files;
        },

        emptyModel() {
            return {
                DeleteExistingRecords: false,
                Files: [],
            }
        },

        async onSaveModelDataSource() {
            try {
                if (this.formFiles().length === 0) {
                    this.modelErrors = `File is required`;
                    return false;
                }

                this.loading = true;

                let formData = new FormData();

                formData.append('json', JSON.stringify(this.model));

                Array.from(this.formFiles()).map((file, index) => {
                    return formData.append('files', file, file.name);
                });

                let url = this.$prepareServerUrl('/api/ui/trading_items/{id}/{applicationId}/{senderId}/{receiverId}/import', this.modelId, this.modelObject);
                let response = await this.$http.post(url, formData, {});

                this.$processServerJsonResponse(response.body, this.refreshScreen);

                this.model = response.body;
                return true;
            }
            catch (ex) {
                this.modelErrors = null;

                if (ex.body.errors) {
                    this.modelErrors = ex.body.errors;
                    return false;
                } else {
                    this.$processException(ex);
                }

                return false;
            }
            finally {
                this.loading = false;
            }
        },

        show() {
            this.model = this.modelObject ?? this.emptyModel();
            this.$refs.dialog.show();
        },

        hide() {
            this.$refs.dialog.hide();
        },

        onDialogHide() {
            this.$emit('hide');
        },

        async onOkClick() {
            let validateResult = await this.$refs.modelForm.validate();
            if (validateResult) {
                let saveResult = await this.onSaveModelDataSource();
                if (saveResult) {
                    this.$emit('ok', { index: this.index, model: this.model, files: null });
                    this.hide();
                }
            }
        },

        onCancelClick() {
            this.hide();
        },

        onRejected() {
            this.$q.dialog({
                title: 'Error',
                message: `Only Excel files are allowed`
            });
        }
    }
}